import React from 'react'
import PropTypes from 'prop-types'

import BuilderLP from './BuilderLP'
import BuilderIsolatedPage from './BuilderLP/BuilderIsolatedPage'
import { useMeta, useTitle } from 'hooks/useMetaTitle'
import { OG_DESCRIPTION } from 'components_v2/common'
const SO_HOME_TITLE = 'ALO Wellness Club | Your At-Home Studio'

const Home = () => {
  useTitle(SO_HOME_TITLE)
  useMeta([
    { name: 'description', content: OG_DESCRIPTION },
    { property: 'fb:app_id', content: window?.REACT_ENV_VARIABLES?.FB_APP_ID },
    { property: 'og:title', content: SO_HOME_TITLE },
    { property: 'og:type', content: 'website' },
    { property: 'og:url', content: window.location.origin },
    { property: 'og:description', content: OG_DESCRIPTION },
    {
      property: 'og:image',
      content: 'https://d28gwrkukqy4h7.cloudfront.net/homepage/briohny.jpg'
    },
    { property: 'og:image:width', content: '1080' },
    { property: 'og:image:height', content: '720' },
    { name: 'p:domain_verify', content: '299e72b8110a92f4070a4822c1fd88c7' },
    { name: 'twitter:card', content: 'app' },
    { name: 'twitter:app:id:iphone', content: 'id601617403' },
    { name: 'twitter:app:id:ipad', content: 'id601617403' },
    { name: 'twitter:app:country', content: 'us' }
  ])
  return (
    <BuilderIsolatedPage>
      <BuilderLP />
    </BuilderIsolatedPage>
  )
}

Home.propTypes = {
  heroVideos: PropTypes.object,
  heroHeader: PropTypes.object,
  banner: PropTypes.object,
  trialBanner: PropTypes.object
}

export default Home
